<template>
    <div class="changelogs">
        <router-link class="hidden | xl:block" :to="{ name: 'chat' }" v-if="!$configs.inIframe">
            <img
                alt="Activix Logo"
                class="w-32 hidden | 2xl:block"
                src="/img/activix-dark-mono.png"
            >
            <img
                alt="Activix Logo"
                class="w-8 | 2xl:hidden"
                src="/img/activix-icon-dark-mono.png"
            >
        </router-link>
        <button :class="{ 'xl:hidden': !$configs.inIframe}" @click="onClick">
            <img
                alt="Activix Logo"
                class="w-32 hidden | sm:block"
                src="/img/activix-dark-mono.png"
            >
            <img
                alt="Activix Logo"
                class="w-8 | sm:hidden"
                src="/img/activix-icon-dark-mono.png"
            >
        </button>
    </div>
</template>

<script>
    export default {
        methods: {
            onClick() {
                this.$bus.emit('conversationList.open');
            },
        },
    };
</script>
